/**
 * App JS
 */
"use strict";

// polyfill for older browsers
require("core-js");

const $ = require("jquery");
const Components = require("./components/index");
const AppHelper = require("./app-helper");

// create the components for the page
AppHelper.methods.createComponents({
	$el: $(document),
	errorMsg: "No component found for",
	dataAttr: "data-comp",
	components: Components,
});
